//require('./style.scss');
//require('file-loader!./demo.html');
require('!style-loader!css-loader!sass-loader!./style.scss');

(function(){

  /* 使用方式: 在網頁內引入script，並插入以下訊息(?rand 參數非必要，但可避免日後調整時的cache問題)*****

<script src="sysnotify.js?rand=202006031921"></script>
<script>
window['sysnotify'] = {
  key: '202006031922', 
  title: '20200615系統停機公告',
  content: '本系統因伺服器機房進行DNS轉換作業，將停機中斷服務24小時。\n停機時間: 2020-06-15 14:00 ~ 2020-06-16 14:00 \n若提前完成轉換將會提早開始恢復服務，造成不便敬請見諒。',
  confirmButtonText: '確定',
  expires: '2020-06-04 16:35'
};  
</script>

  *****不使用時，將上述訊息移除即可。 
  
  如果頁面上有z-index特高的項目會遮蓋公告，在 script 前補以下代碼

  <style>
  .notify-dialog { z-index: 100; }
  </style>
  
  z-index 高過頁面上元素即可
  */

  window.addEventListener('DOMContentLoaded', ()=>{
    let notifyItem = window['sysnotify'];
    document.body.setAttribute('restore-overflow', document.body.style.overflow);
    //if (notifyItems.length == 0) return;
    //let notifyItem = notifyItems[0];
    if (typeof(notifyItem) == 'undefined') return;
    const cookieKey = 'sysnotify';
    let foundIndex = findByKey(cookieKey, notifyItem.key);
    
    let expires = notifyItem.expires;
    if (typeof(expires) != 'undefined' ){
      if (new Date(expires) - Date.now() < 0){
        // 訊息過期
        if (foundIndex>=0){
          removeByKey(cookieKey);
          //console.log('remove cookie');
        }
        return;
      } 
    }
    
    let dialog = prepareDialog(notifyItem);
    
    // read cookie

    if (foundIndex<0){
      //console.log('cookie not found, or expired, writing a new one.');
      writeNew([cookieKey,notifyItem.key].join('='));
      setTimeout(showDialog,100);
      
    }else{
      //console.log('cookie found, and not expired, do nothing.');
    }
    
  }, false);
  
  // ****** cookie ******
  function findByKey(key, checkValue){
    let cookies = document.cookie.split('; ');
    for (let i=0;i<cookies.length;i++){
      let cookieParts = cookies[i].split('=');
      if (cookieParts.length === 2 && cookieParts[0] === key && cookieParts[1] === checkValue){  return i; }
    }  
    return -1;
  }
  
  function writeByIndex(index, value){
    let cookies = document.cookie.split('; ');
    cookies[index] = value;
    document.cookie = cookies.join('; ');
  }
   
  function writeNew(value){
    writeByIndex(0, value);
  }
  function removeByKey(key){
    document.cookie = key+'=; expires=Thu, 01 Jan 1970 00:00:00 GMT';
  }
  
  // ****** cookie ******
   
  function prepareDialog(notifyItem){

    //document.body.style.marginTop = '1em';
    //document.body.style.transition = 'margin-top 166ms ease-in';
    let referenceNode = document.body.childNodes[0];

    let container = el({
      classNames:['notify-dialog'],
      eventBinding: {'click': confirmNotify},
      childNodes:[{
        classNames:['notify-dialog-card'],
        eventBinding: {'click': showDialog},
        childNodes:[{
          classNames:['notify-dialog-header'],
          childNodes: [{text: notifyItem.title}]
        },{
          classNames:['notify-dialog-body'],
          childNodes:[{
            html: notifyItem.content
          },{
            tagName: 'button',
            attributes: {type:'button'},
            classNames:['notify-dialog-button'],
            eventBinding: {'click': confirmNotify},
            //text: notifyItem.confirmButtonText
            childNodes: [{text: notifyItem.confirmButtonText}],
          }]
        }]
      }]
    });

    /*
    let container = document.createElement('div');
    container.className = 'notify-dialog';
    //container.style.cssText = 'opacity:0; box-sizing: border-box; border: none; background-color: #ffc; position: absolute; top:0; left:0; height:0; overflow: hidden; width: 100%; text-align:center; transition: all 500ms ease-in;';
    

    let cardHeader = document.createElement('div');
    cardHeader.className = 'notify-dialog-header';
    //cardHeader.style.cssText = 'font-weight: bold; font-size: 120%';
    cardHeader.appendChild(document.createTextNode(notifyItem.title));
    let cardBody = document.createElement('div');
    cardBody.className = 'notify-dialog-body';
    //cardBody.style.cssText = 'font-size: 80%';
    //cardBody.style.whiteSpace = 'pre-line';
    cardBody.appendChild(document.createTextNode(notifyItem.content));
    let card = document.createElement('div');
    card.className = 'notify-dialog-card';
    //card.style.cssText = 'width: 80%; margin: 0 auto;text-align: left; font-family: "微軟正黑體", consolas, arial ;';
    card.appendChild(cardHeader);
    card.appendChild(cardBody);
    card.addEventListener('click', showDialog, false);
    let confirmButton = document.createElement('button');
    confirmButton.attributes['type'] = 'button';
    confirmButton.className = 'notify-dialog-button';
    //confirmButton.style.cssText = 'background-color: #fff;border: 1px solid #369;border-radius: 5px;padding: 2px 4px; font-family: "微軟正黑體", consolas, arial ;';
    confirmButton.appendChild(document.createTextNode(notifyItem.confirmButtonText));
    cardBody.appendChild(confirmButton);
    confirmButton.addEventListener('click', confirmNotify, false);
    container.appendChild(card);
    */
    document.body.insertBefore(container, referenceNode);// appendChild(container);
    return container;
  }

  function el(options){
    let tagName = options.tagName||'div';
    let x = document.createElement(tagName);
    if (options){
      for (let k in options.attributes){
        x.setAttribute(k, options.attributes[k]);
      }
      for (let k in options.styles){
        x.styles[k] = options.styles[k];
      }
      if (options.classNames) x.className = options.classNames.join(' ');
      for (let k in options.eventBinding){
        x.addEventListener(k, options.eventBinding[k], false);
      }
      if (options.html){
        x.innerHTML = options.html;
      }else if (options.text){
        x.textContent = options.text;
      }else if (options.childNodes){
        for (let k in options.childNodes){
          let child = options.childNodes[k];
          if (child.html){
            x.insertAdjacentHTML( 'beforeend', child.html );
          }else if (child.text){
            x.insertAdjacentText('beforeend', child.text );
          }else {
            x.appendChild(el(child));
          }
          
        }
  
      }
    }
    return x;
  }

  function showDialog(e){
    document.querySelector('.notify-dialog').classList.add('focus');
    
    document.body.style.overflow = 'hidden';
    if(e)e.stopPropagation();
  }
  
  function confirmNotify(e){
    //console.log('Confirmed!');
    document.querySelector('.notify-dialog').classList.remove('focus');
    
    document.body.style.overflow = document.body.getAttribute('restore-overflow');
    e.stopPropagation();
    e.preventDefault();
  }
 
})();